<template>
  <div v-if="logoComponent" class="mr-40">
    <h2 class="h3 mb-32">
      <strong>{{ $t('a-service-from') }}</strong>
    </h2>
    <a :href="logoHref" target="_blank">
      <component :is="logoComponent" />
    </a>
  </div>
</template>
<script setup>
  import { inject } from 'vue'
  import FinnLogo from './assets/FinnLogo.vue'
  import BlocketLogo from './assets/BlocketLogo.vue'
  import { configInjectionKey } from './injectionKeys.js'

  const { topLevelDomain } = inject(configInjectionKey)

  let logoComponent
  let logoHref
  switch (topLevelDomain.toUpperCase()) {
    case 'NO':
      logoComponent = FinnLogo
      logoHref = 'https://www.finn.no'
      break
    case 'SE':
      logoComponent = BlocketLogo
      logoHref = 'https://www.blocket.se'
      break
    default:
      logoComponent = undefined
      break
  }
</script>
<style scoped>
.h3 {
  font-family: Inter, serif;
  font-size: 22px;
  line-height: 28px;
}
</style>